'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var theme_common_getTheme = require('../common/getTheme.js');
var theme_CoreTheme_olxPalette = require('./olxPalette.js');
require('../common/tokens/borders.js');
require('../common/primitives/commonPrimitives.js');
require('../common/primitives/defaultPrimitives.js');
require('../common/tokens/typography.js');
require('../common/tokens/spacing.js');
require('../common/tokens/breakpoints.js');
require('@babel/runtime/helpers/toConsumableArray');
require('@babel/runtime/helpers/defineProperty');
require('@emotion/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);

var colorTokens = {
  'background-global-primary': theme_CoreTheme_olxPalette.olxPalette['$01_white'],
  'background-global-secondary': theme_CoreTheme_olxPalette.olxPalette['$03_gray'],
  'background-global-inverse': theme_CoreTheme_olxPalette.olxPalette['$07_charcoal'],
  'background-brand-primary': theme_CoreTheme_olxPalette.olxPalette['$07_charcoal'],
  'background-brand-primary-light': theme_CoreTheme_olxPalette.olxPalette['$05_gray'],
  'background-brand-secondary': theme_CoreTheme_olxPalette.olxPalette['$05_teal_primary'],
  'background-brand-secondary-light': theme_CoreTheme_olxPalette.olxPalette['$02_teal_light'],
  'background-brand-tertiary': theme_CoreTheme_olxPalette.olxPalette['$04_gray'],
  'background-brand-disabled': theme_CoreTheme_olxPalette.olxPalette['$04_gray'],
  'background-brand-badge': theme_CoreTheme_olxPalette.olxPalette['$07_charcoal'],
  'background-brand-fields-active': theme_CoreTheme_olxPalette.olxPalette['$03_gray'],
  'background-brand-fields-disabled': theme_CoreTheme_olxPalette.olxPalette['$02_gray'],
  'background-brand-fields-inverse': theme_CoreTheme_olxPalette.olxPalette['$01_white'],
  'background-brand-alternative': theme_CoreTheme_olxPalette.olxPalette['$06_blue_dark'],
  'background-brand-alternative-light': theme_CoreTheme_olxPalette.olxPalette['$04_blue_tint_dark'],
  'background-brand-error': theme_CoreTheme_olxPalette.olxPalette['$05_red_primary'],
  'background-brand-highlight-primary': theme_CoreTheme_olxPalette.olxPalette['$05_teal_primary'],
  'background-brand-highlight-secondary': theme_CoreTheme_olxPalette.olxPalette['$02_yellow_light'],
  'background-brand-tooltip': theme_CoreTheme_olxPalette.olxPalette['$05_blue_primary'],
  'background-brand-notification-dot': theme_CoreTheme_olxPalette.olxPalette['$05_yellow_primary'],
  'background-brand-notification-warning': theme_CoreTheme_olxPalette.olxPalette['$02_yellow_light'],
  'background-brand-notification-error': theme_CoreTheme_olxPalette.olxPalette['$02_red_light'],
  'background-brand-notification-success': theme_CoreTheme_olxPalette.olxPalette['$02_teal_light'],
  'background-brand-notification-neutral': theme_CoreTheme_olxPalette.olxPalette['$02_blue_light'],
  'background-brand-discount': '',
  'background-brand-confirmationScreen-success': theme_CoreTheme_olxPalette.olxPalette['$01_teal_bg_light'],
  'background-brand-confirmationScreen-warning': theme_CoreTheme_olxPalette.olxPalette['$01_yellow_bg_light'],
  'background-brand-confirmationScreen-error': theme_CoreTheme_olxPalette.olxPalette['$01_red_bg_light'],
  'background-brand-chat-highlight': theme_CoreTheme_olxPalette.olxPalette['$02_blue_light'],
  'background-brand-inverse': theme_CoreTheme_olxPalette.olxPalette['$07_charcoal'],
  'text-brand-primary': theme_CoreTheme_olxPalette.olxPalette['$07_charcoal'],
  'text-brand-alternative': theme_CoreTheme_olxPalette.olxPalette['$05_blue_primary'],
  'text-global-primary': theme_CoreTheme_olxPalette.olxPalette['$07_charcoal'],
  'text-global-secondary': theme_CoreTheme_olxPalette.olxPalette['$06_gray'],
  'text-global-disabled': theme_CoreTheme_olxPalette.olxPalette['$05_gray'],
  'text-global-inverse': theme_CoreTheme_olxPalette.olxPalette['$01_white'],
  'text-global-highlight': theme_CoreTheme_olxPalette.olxPalette['$07_charcoal'],
  'text-global-error': theme_CoreTheme_olxPalette.olxPalette['$05_red_primary'],
  'text-brand-highlight': theme_CoreTheme_olxPalette.olxPalette['$06_teal_dark'],
  'icon-brand-primary': theme_CoreTheme_olxPalette.olxPalette['$07_charcoal'],
  'icon-brand-alternative': theme_CoreTheme_olxPalette.olxPalette['$05_blue_primary'],
  'icon-global-primary': theme_CoreTheme_olxPalette.olxPalette['$07_charcoal'],
  'icon-global-secondary': theme_CoreTheme_olxPalette.olxPalette['$06_gray'],
  'icon-global-disabled': theme_CoreTheme_olxPalette.olxPalette['$05_gray'],
  'icon-global-inverse': theme_CoreTheme_olxPalette.olxPalette['$01_white'],
  'icon-global-highlight': theme_CoreTheme_olxPalette.olxPalette['$05_teal_primary'],
  'icon-global-error': theme_CoreTheme_olxPalette.olxPalette['$05_red_primary'],
  'icon-global-chat-highlight': theme_CoreTheme_olxPalette.olxPalette['$05_blue_primary'],
  'borders-brand-primary': theme_CoreTheme_olxPalette.olxPalette['$07_charcoal'],
  'borders-brand-secondary': theme_CoreTheme_olxPalette.olxPalette['$05_teal_primary'],
  'borders-brand-alternative': theme_CoreTheme_olxPalette.olxPalette['$05_blue_primary'],
  'borders-global-primary': theme_CoreTheme_olxPalette.olxPalette['$07_charcoal'],
  'borders-global-secondary': theme_CoreTheme_olxPalette.olxPalette['$05_gray'],
  'borders-global-tertiary': theme_CoreTheme_olxPalette.olxPalette['$04_gray'],
  'borders-global-inverse': theme_CoreTheme_olxPalette.olxPalette['$01_white'],
  'borders-global-highlight': theme_CoreTheme_olxPalette.olxPalette['$01_blue_bg_light'],
  'borders-global-error': theme_CoreTheme_olxPalette.olxPalette['$05_red_primary'],
  'borders-global-focus': theme_CoreTheme_olxPalette.olxPalette['$05_blue_primary'],
  transparent: theme_CoreTheme_olxPalette.olxPalette['$01_alpha_transparent'],
  shimmer: theme_CoreTheme_olxPalette.olxPalette['$01_alpha_shimmer'],
  'elevation-1': theme_CoreTheme_olxPalette.olxPalette['$02_alpha_black_16'],
  'elevation-2-backdrop': theme_CoreTheme_olxPalette.olxPalette['$04_alpha_charcoal_80'],
  /* interactions */
  'light-s': theme_CoreTheme_olxPalette.olxPalette['$03_alpha_white_24'],
  'light-m': theme_CoreTheme_olxPalette.olxPalette['$04_alpha_white_40'],
  'light-l': theme_CoreTheme_olxPalette.olxPalette['$05_alpha_white_64'],
  'dark-s': theme_CoreTheme_olxPalette.olxPalette['$02_alpha_black_16'],
  'dark-m': theme_CoreTheme_olxPalette.olxPalette['$03_alpha_black_24'],
  'dark-l': theme_CoreTheme_olxPalette.olxPalette['$04_alpha_black_48'],
  'dark-xl': theme_CoreTheme_olxPalette.olxPalette['$05_alpha_black_64']
};
var theme = theme_common_getTheme.getTheme({
  consumerName: 'OLX',
  fonts: {
    primary: 'Geomanist',
    family: 'Geomanist, sans-serif'
  },
  colors: _objectSpread__default["default"](_objectSpread__default["default"]({}, theme_CoreTheme_olxPalette.olxPalette), colorTokens)
});

exports.colorTokens = colorTokens;
exports.theme = theme;
//# sourceMappingURL=coreTheme.js.map
